"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M6.71 11.88h6.057V8.11h1v3.859a.912.912 0 0 1-.911.91h-9.98a.913.913 0 0 1-.912-.91V7.103L.008 7.102.72 6.19l1.662-2.365.287-.038 10.666.015.246.31 2.252 2.99H8.222l-.235-.287L6.71 5.12v6.76ZM4.793 4.79 2.93 4.787l-.924 1.315H3.87l.922-1.312Zm-.405 2.314-1.423-.001v4.777H5.71V5.22L4.387 7.105ZM12.85 4.8l.978 1.3H8.7l-.984-1.307 5.133.007Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M19.67 17.626a.076.076 0 0 0 .076-.076v-5.985h1.125v5.985c0 .663-.539 1.201-1.201 1.201H4.187a1.202 1.202 0 0 1-1.201-1.2V9.786l-2.81-.001.836-1.07 2.522-3.588.334-.06 16.445.025.318.4 3.233 4.293H12.582l-.3-.366-2.359-3.133v11.34h9.747ZM7.57 6.2l-3.41-.005L2.424 8.66H5.84L7.57 6.2ZM4.11 9.787v7.763c0 .042.034.076.077.076h4.611V6.408l-2.376 3.38H4.111Zm15.657-3.57 1.84 2.444h-8.489l-1.849-2.456 8.498.012Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M26.226 23.501a.1.1 0 0 0 .101-.1v-7.982h1.5V23.4c0 .883-.718 1.601-1.6 1.601H5.581a1.603 1.603 0 0 1-1.602-1.6V13.048l-3.747-.002 1.116-1.425L4.71 6.836l.446-.079 21.926.032.424.534 4.311 5.723H16.776l-.4-.487-3.146-4.178v15.12h12.996ZM10.092 8.266 5.545 8.26l-2.312 3.288h4.552l2.307-3.28ZM5.48 13.05V23.4a.1.1 0 0 0 .102.101h6.148V8.543L8.562 13.05H5.48Zm20.876-4.76 2.452 3.258H17.49l-2.465-3.274 11.331.016Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M38.977 37.73c.19 0 .344-.154.344-.343V25.38h1.875v12.007a2.221 2.221 0 0 1-2.219 2.218H7.92a2.221 2.221 0 0 1-2.22-2.218V21.62H.265l1.437-1.836 5.09-7.244 33.382.048.582.732 6.25 8.3H24.854l-.546-.663-4.911-6.523-.16-.001V37.73h19.741Zm-23.904-23.3-7.307-.011-3.745 5.328h7.313l3.739-5.317Zm-7.497 7.19v15.766c0 .189.155.343.344.343h9.442V14.432l-5.058 7.194-1.08-.005H7.576Zm31.692-7.158 3.977 5.283H25.74l-3.995-5.308 17.523.025Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M51.97 50.307a.459.459 0 0 0 .458-.458V33.84h2.5v16.01a2.961 2.961 0 0 1-2.958 2.957H10.56a2.961 2.961 0 0 1-2.958-2.958V28.83H.353l1.917-2.45 6.787-9.658 44.509.064.775.975 8.335 11.067H33.137l-.728-.884-6.548-8.698h-.212v31.061H51.97ZM20.097 19.238l-9.742-.014-4.994 7.104h9.751l4.985-7.09Zm-9.995 9.59V49.85a.46.46 0 0 0 .458.458h12.589V19.243l-6.743 9.592-1.441-.007h-4.863Zm42.256-9.544 5.302 7.044H34.32l-5.326-7.078 23.364.034Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconPackage = function IconPackage(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Package' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Package"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconPackage.sizes = [16, 24, 32, 48, 64];
IconPackage.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconPackage;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/account-experience/Package.js
// module id = 1801
// module chunks = 0